import React, { useState, useEffect } from "react";
import "react-tabs/style/react-tabs.css";
import { useHistory } from "react-router-dom";
import { Button } from "../ui/button";
import GanttComponent from "../GanntChart";
import Wbs from "../WBS";
import Kanban from "../Kanban";
import api from "../../services/api";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { InputIcon } from "../ui/input";
import { stepsPlanejamento } from "../Tour/steps";
import { useTour } from "@reactour/tour";
import Tour from "../Tour";
import ModalEditNameEpic from "../ModalEditNameEpic/ModalEditNameEpic";
import { Loader2 } from "lucide-react";
import { Input } from "../ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
// import { useToast } from "../ui/use-toast";
import { toast, Bounce, ToastContainer } from "react-toastify";
import ReactSelect from "react-select";
// import html2canvas from 'html2canvas';
import ModeloEpicos from './ModeloDePreenchimento.xlsx';
import { Calendar } from '../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { CalendarIcon } from "@radix-ui/react-icons";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const generatePagination = (currentPage, totalPages) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, '...', totalPages];
  }

  if (currentPage >= totalPages - 2) {
    return [1, '...', totalPages - 2, totalPages - 1, totalPages];
  }

  return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
};

export default function PlanejamentoDeProjeto() {
  const history = useHistory();

  const [projetos, setProjetos] = useState([]);
  const [epicos, setEpicos] = useState([]);
  const [selectedOption, setSelectedOption] = useState("0");
  const [statusEpicos, setStatusEpicos] = useState([]);
  const [epicoSelecionadoGantt, setEpicoSelecionadoGantt] = useState("");
  const [statusSelecionadoGantt, setStatusSelecionadoGantt] = useState("");
  const [epicoSelecionado, setEpicoSelecionado] = useState("0");
  const [statusSelecionado, setStatusSelecionado] = useState("0");
  const [idProjeto, setIdProjeto] = useState("");
  const [termoPesquisa, setTermoPesquisa] = useState("");
  const [termoPesquisaGantt, setTermoPesquisaGantt] = useState("");
  const [ganttHasData, setGanttHasData] = useState(false);
  const [epicFile, setEpicFile] = useState(null);
  const [previewEpics, setPreviewEpics] = useState([]);
  const [previewToken, setPreviewToken] = useState("");
  const [, setSelectedEpics] = useState({});
  const [uploading, setUploading] = useState(false);
  // const { toast } = useToast();
  const [selectedUploadProject, setSelectedUploadProject] = useState("");
  const { setSteps } = useTour();
  const [, setUploadProjects] = useState([]);
  const [sheetTabs, setSheetTabs] = useState([]);
  const [sheetName, setSheetName] = useState("");
  // const [excelColumns, setExcelColumns] = useState([]);
  const [activeTab, setActiveTab] = useState("gantt");
  const [epicManagementStep, setEpicManagementStep] = useState(1);
  const [projectTags, setProjectTags] = useState([]);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataInicioGantt, setDataInicioGantt] = useState(null);

  const [fieldMappings, setFieldMappings] = useState(() => {
    const initialMappings = [];
    initialMappings.push({
      id: Date.now() + Math.random(),
      cell: "",
      columnId: "", // Added columnId
      taigaField: "",
    });
    return initialMappings;
  });

  const availableMappings = [
    { value: "epic_name", label: "NOME DO ÉPICO" },
    { value: "description_epic", label: "DESCRIÇÃO DO ÉPICO" },
    { value: "hours_epic", label: "HORAS DO ÉPICO" },
    { value: "history_user", label: "HISTÓRIA DO USUÁRIO" },
    { value: "description_hu", label: "DESCRIÇÃO DA HU" },
    { value: "hours_hu", label: "HORAS DA HU" },
    { value: "start_date", label: "DATA DE INÍCIO" },
    { value: "end_date", label: "DATA DE FIM" },
  ];

  const [storyTags, setStoryTags] = useState({});


  const pageWidth = {
    width: "min(95vw, 1800px)",
    margin: "0 auto",
  };

  useEffect(() => {
    setSteps(stepsPlanejamento);
    const getProjetos = async () => {
      try {
        const response = await api.get("/api/planejamentoProjetos");
        const projetosData = response.data;
        setProjetos(projetosData);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    const getUserInfo = async () => {
      try {
        let token = localStorage.getItem("auth-token");
        const response = await api.get("/api/user/perfil", {
          headers: { "x-auth-token": token },
        });
        const userData = response.data;
        if (!userData.isProjectManager) {
          return history.push("/perfil");
        }
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    getUserInfo();
    getProjetos();
  }, [history, setSteps]);

  useEffect(() => {
    const getEpicos = async () => {
      try {
        const response = await api.get("/api/buscarEpicos");
        const epicosData = response.data;
        setEpicos(epicosData);
      } catch (error) {
        console.error("Erro ao buscar epicos:", error);
      }
    };

    getEpicos();
  }, []);

  useEffect(() => {
    const getStatusEpicos = async () => {
      try {
        const response = await api.get("/api/buscarStatusEpicos");
        const statusEpicosData = response.data;
        setStatusEpicos(statusEpicosData);
      } catch (error) {
        console.error("Erro ao buscar epicos:", error);
      }
    };

    getStatusEpicos();
  }, []);

  useEffect(() => {
    const fetchTags = async () => {
      if (!selectedUploadProject) {
        setProjectTags([]);
        return;
      }
      try {
        const { data } = await api.get('/findTags', {
          params: { projectId: selectedUploadProject }
        });

        if (data.tags && typeof data.tags === 'object' && !Array.isArray(data.tags)) {
          const formattedTags = Object.entries(data.tags).map(([tag, color]) => ({
            value: tag,
            label: tag,
            color: color || '#A3A3A3' // cor de fallback
          }));
          console.log('Formatted Tags for ReactSelect:', formattedTags);
          setProjectTags(formattedTags);
        } else if (Array.isArray(data.tags)) {
          const formattedTags = data.tags.map(([tag, color]) => ({
            value: tag,
            label: tag,
            color: color || '#A3A3A3' // cor de fallback
          }));
          console.log('Formatted Tags for ReactSelect (array path):', formattedTags);
          setProjectTags(formattedTags);
        } else {
          console.warn('API response for tags did not return an expected object or array:', data.tags);
          setProjectTags([]);
        }

      } catch (error) {
        console.error('Erro ao buscar etiquetas do projeto:', error);
        setProjectTags([]) // em caso de erro, limpa
      }
    };
    fetchTags();
  }, [selectedUploadProject]);

  const handleInitialUpload = async () => {
    if (!epicFile || !selectedUploadProject) {
      toast.warn('Selecione um arquivo e um projeto de destino.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      return;
    }
    setUploading(true);

    setEpicManagementStep(2);
    setUploading(false);
  };

  const handleUploadEpics = async () => {
    if (!previewToken || previewEpics.length === 0 || !selectedUploadProject) {
      toast.warn('Dados de pré-visualização ou projeto de destino ausentes.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      return;
    }
    setUploading(true);
    const epicsWithTags = previewEpics.map((epic) => ({
      subject: epic.subject,
      description: epic.description,
      tags: epic.tags || [],
      tempoEsperado: epic.tempoEsperado,
      stories: epic.stories?.map((story, idx) => ({
        subject: story.subject,
        description: story.description,
        inicio: story.inicio,
        fim: story.fim,
        tempoGasto: story.tempoGasto,
        tags: getTagArray(storyTags[`${epic.subject}-${idx}`] || []),
      }))
    }));

    try {
      const response = await api.post("/upload-taiga-epic", {
        token: previewToken,
        epicsWithTags,
        projectId: selectedUploadProject,
      });
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      setPreviewEpics([]);
      setPreviewToken("");
      setSelectedEpics({});
      setSelectedUploadProject("");
      setEpicFile(null);
      setEpicManagementStep(1);
      setStoryTags({});
      setSheetTabs([]);
      setSheetName('');
      setFieldMappings(() => {
        const initialMappings = [];
        for (let i = 0; i < 1; i++) {
          initialMappings.push({
            id: Date.now() + Math.random() + i,
            cell: "",
            columnId: "",
            taigaField: "",
          });
        }
        return initialMappings;
      });
      setActiveTab("gantt");
    } catch (err) {
      console.error("Erro ao enviar épicos:", err);
      // const description = "Ocorreu um erro inesperado ao enviar os épicos. Tente novamente.";
      toast.error('Erro ao enviar épicos!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } finally {
      setUploading(false);
      setSelectedUploadProject("");
      setEpicFile(null);
    }
  };

  const handleFieldChange = (id, fieldName, value) => {
    setFieldMappings(fieldMappings.map(mapping =>
      mapping.id === id ? { ...mapping, [fieldName]: value } : mapping
    ));
  };

  const handleAddMappingRow = () => {
    setFieldMappings(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        cell: "",
        columnId: "", // Added columnId
        taigaField: "",
      }
    ]);
  };

  const handleRemoveMappingRow = (idToRemove) => {
    if (fieldMappings.length <= 1) {
      toast.warn('Não é possível remover a última linha de mapeamento.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      return;
    }
    setFieldMappings(prev =>
      prev.filter(mapping => mapping.id !== idToRemove)
    );
  };

  const handleMapAndPreview = async () => {
    setUploading(true);
    console.log("Starting handleMapAndPreview..."); // Log 1

    const formData = new FormData();
    formData.append("file", epicFile);
    formData.append("sheetName", sheetName);
    formData.append("epicColumns", epicColumns);
    formData.append("huColumns", huColumns);
    formData.append("descColumns", descColumns);
    formData.append("epicDescColumns", epicDescColumns);
    formData.append("inicioColumns", inicioColumns);
    formData.append("fimColumns", fimColumns);
    formData.append("tempoEsperadoColumns", tempoEsperadoColumns);
    formData.append("tempoGastoColumns", tempoGastoColumns);
    formData.append("epicHoursColumns", epicHoursColumns);
    console.log("FormData prepared.");

    try {
      const response = await api.post('/preview-epics', formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setPreviewEpics(response.data.epics);
      setPreviewToken(response.data.token);
      setUploadProjects(response.data.projects);
      setSelectedEpics(
        Object.fromEntries(response.data.epics.map((e) => [e.subject, false]))
      );
      setEpicManagementStep(3);
    } catch (error) {
      console.error("Error during handleMapAndPreview:", error);
      toast.error('Erro ao mapear e visualizar os épicos!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      setEpicManagementStep(2);
    } finally {
      console.log("Finished handleMapAndPreview, setting uploading to false.");
      setUploading(false);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    setEpicFile(file);
    setSheetTabs([]);
    setSheetName('');
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await api.post('findTabs', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setSheetTabs(response.data.sheetNames || []);
        if (response.data.sheetNames?.length) setSheetName(response.data.sheetNames[0]);
      } catch (error) {
        setSheetTabs([]);
        setSheetName('');
      }
    }
  };

  const epicColumns = fieldMappings
    .filter(f => f.taigaField === "epic_name" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const huColumns = fieldMappings
    .filter(f => f.taigaField === "history_user" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const descColumns = fieldMappings
    .filter(f => f.taigaField === "description_hu" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const epicDescColumns = fieldMappings
    .filter(f => f.taigaField === "description_epic" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const tempoEsperadoColumns = fieldMappings
    .filter(f => f.taigaField === "tempoEsperado" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const tempoGastoColumns = fieldMappings
    .filter(f => (f.taigaField === "tempoGasto" || f.taigaField === "hours_hu") && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const epicHoursColumns = fieldMappings
    .filter(f => f.taigaField === "hours_epic" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const inicioColumns = fieldMappings
    .filter(f => f.taigaField === "start_date" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  const fimColumns = fieldMappings
    .filter(f => f.taigaField === "end_date" && f.cell)
    .map(f => extractColumnLetter(f.cell))
    .filter(Boolean)
    .join(",");

  function extractColumnLetter(cell) {
    const match = (cell || "").toUpperCase().match(/^[A-Z]+/);
    return match ? match[0] : "";
  }

  // Normaliza strings: remove acentos e converte para minúsculas
  function normalizeString(s) {
    if (!s) return "";
    return String(s).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  }

  const handleDownloadModel = () => {
    const link = document.createElement('a');
    link.href = ModeloEpicos;
    link.setAttribute('download', 'modelo_epicos.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleStoryTagsChangeReactSelect = (epicSubject, storyIdx, selectedOptions) => {
    setStoryTags(prev => ({
      ...prev,
      [`${epicSubject}-${storyIdx}`]: selectedOptions ? selectedOptions.map(opt => opt.value) : [],
    }));
  };

  function getTagArray(tagValues) {
    if (!Array.isArray(tagValues)) return [];
    return tagValues.map(tag =>
      [tag, projectTags.find(opt => opt.value === tag)?.color || "#A3A3A3"]
    );
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageOptions = [5, 10, 20, 50];
  const totalPages = Math.ceil(previewEpics.length / itemsPerPage);
  const paginatedEpics = previewEpics.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const itemsPerPageSelectOptions = itemsPerPageOptions.map(opt => ({
    value: opt,
    label: String(opt),
  }));

  const tagSelectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: 'transparent',
      minHeight: '38px',
      flexWrap: 'wrap',
      alignItems: 'center',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : base.boxShadow,
      borderColor: state.isFocused ? '#2684FF' : base.borderColor,
      minWidth: '180px',
    }),
    valueContainer: (base) => ({
      ...base,
      flexWrap: 'wrap',
      gap: '4px',
      padding: '4px 8px',
      minHeight: '30px',
    }),
    multiValue: (base, { data }) => ({
      ...base,
      backgroundColor: `${data.color}20`,
      borderRadius: '6px',
      padding: '2px 6px',
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    multiValueLabel: (base, { data }) => ({
      ...base,
      color: data.color,
      fontWeight: 500,
      fontSize: '0.875rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    multiValueRemove: (base, { data }) => ({
      ...base,
      color: data.color,
      ':hover': {
        backgroundColor: `${data.color}33`,
        color: data.color,
      },
    }),
    placeholder: (base) => ({
      ...base,
      position: 'unset',
      left: 'unset',
      right: 'unset',
      zIndex: 'unset',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: 'calc(100% - 40px)',
      color: '#A1A1AA',
    }),
    input: (base) => ({
      ...base,
      padding: '0',
      margin: '0',
      flexGrow: 1,
      minWidth: '80px',
      display: 'flex',
      alignItems: 'center',
    }),
    singleValue: (base) => ({
      ...base,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      flexShrink: 0,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
  };

  return (
    <>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <nav
          className="navigation"
          style={{
            marginTop: '100px',
          }}
        >
          <ul>
            <li>
              <a href="/perfil">Home</a>
            </li>
            <li>/</li>
            <li>
              <a href="/projetos">Gestão de Projetos</a>
            </li>
            <li>/</li>
            <li>
              <a href="/planejamento-projeto">Planejamento de Projetos</a>
            </li>
          </ul>
        </nav>
        <div
          style={{
            ...pageWidth,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderBottom: '2px dashed #0069988C',
            marginBottom: '2rem',
          }}
        >
          <p
            className="planejamento-title"
            style={{
              fontSize: '35px',
              fontFamily: 'Satoshi',
              fontWeight: '700',
              color: '#00293B',
              marginBottom: '1rem',
            }}
          >
            Planejamento de Projeto
          </p>
        </div>

        <div
          style={{
            ...pageWidth,
            display: 'flex',
            gap: '0px',
            marginTop: '1rem',
            marginBottom: '2rem',
            justifyContent: 'flex-start',
            borderRadius: '8px 8px 0 0',
          }}
        >
          {[
            { key: 'gantt', label: 'Gráfico Gantt' },
            // { key: "wbs", label: "WBS" },
            { key: 'epics', label: 'Gerenciar Épicos' },
            { key: 'kanban', label: 'Kanban' },
          ].map((tab, index, arr) => {
            const isActive = activeTab === tab.key;
            const isFirst = index === 0;
            const isLast = index === arr.length - 1;

            return (
              <button
                key={tab.key}
                className={`py -1 px-4 text-sm font-medium ${
                  isActive
                    ? 'bg-white text-[#18181B]'
                    : 'bg-[#F4F4F5] text-[#6B7280]'
                } hover:bg-gray-200 transition-colors`}
                onClick={() => {
                  setActiveTab(tab.key);
                  if (tab.key === 'epics') setEpicManagementStep(1);
                }}
                style={{
                  borderTopLeftRadius: isFirst ? '8px' : 0,
                  borderTopRightRadius: isLast ? '8px' : 0,
                  paddingBottom: '0.25rem',
                  border: isActive ? '1px solid #E5E7EB' : undefined,
                  borderLeft: !isActive ? '1px solid #E5E7EB' : undefined,
                  borderRight:
                    !isActive && !isLast ? '1px solid #E5E7EB' : undefined,
                  borderBottom: !isActive ? '1px solid #E5E7EB' : 'none',
                  marginTop: isActive ? '-2px' : '0',
                  marginBottom: isActive ? '-2px' : '0',
                  marginLeft: isActive ? '-2px' : '0',
                  marginRight: isActive ? '-2px' : '0',
                  position: 'relative',
                  zIndex: isActive ? 2 : 1,
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        {activeTab === 'gantt' && (
          <div style={pageWidth}>
            <div
              style={{
                display: 'flex',
                width: '100%',
                padding: '1rem',
                alignItems: 'center',
                gap: '1rem',
                paddingBottom: '2rem',
              }}
            >
              <InputIcon
                placeholder="Pesquisar por Épico"
                className="w-64 py-0 pesquisaPorEpico"
                value={termoPesquisa}
                onChange={(e) => setTermoPesquisa(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-[18px] w-[16px]" />}
              />
              <Select
                value={selectedOption}
                onValueChange={(value) => {
                  setSelectedOption(value);
                  setStatusSelecionado('');
                  setEpicoSelecionado('');
                }}
              >
                <SelectTrigger className="w-[240px] selectProjectPlanejamento">
                  <SelectValue placeholder="Projeto" />
                </SelectTrigger>
                <SelectContent side="bottom" position="static">
                  <SelectGroup>
                    <SelectItem key={0} value={'0'}>
                      Selecione um Projeto
                    </SelectItem>
                    {projetos.map((projeto) => (
                      <SelectItem
                        key={projeto.id}
                        value={projeto.nome}
                        className={
                          selectedOption === projeto.nome ? 'bg-gray-200' : ''
                        }
                      >
                        {projeto.nome}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>

              <Select
                value={epicoSelecionado}
                onValueChange={(value) => setEpicoSelecionado(value)}
              >
                <SelectTrigger className="w-[240px] selectEpicoPlanejamento">
                  <SelectValue placeholder="Épico" />
                </SelectTrigger>
                <SelectContent side="bottom" position="static">
                  <SelectGroup>
                    <SelectItem key={-1} value={'0'}>
                      Selecione um Épico
                    </SelectItem>
                    {epicos
                      ?.filter(
                        (epico) =>
                          projetos.find(
                            (projeto) => projeto.nome === selectedOption,
                          )?.id === epico?.id_projeto,
                      )
                      .filter((epico) => {
                        if (!termoPesquisa) return true;
                        const term = normalizeString(termoPesquisa);
                        return normalizeString(epico.nome).includes(term);
                      })
                      .map((epico) => (
                        <SelectItem key={epico.id} value={epico.nome}>
                          {epico.nome}
                        </SelectItem>
                      ))}
                  </SelectGroup>
                </SelectContent>
              </Select>

              <Select
                value={statusSelecionado}
                onValueChange={(value) => setStatusSelecionado(value)}
              >
                <SelectTrigger className="w-[240px] selectStatusEpicoPlanejamento">
                  <SelectValue placeholder="Status Épico" />
                </SelectTrigger>
                <SelectContent side="bottom" position="static">
                  <SelectGroup>
                    <SelectItem key={-1} value={'0'}>
                      Selecione um Status
                    </SelectItem>
                    {statusEpicos
                      ?.filter(
                        (status) =>
                          projetos.find(
                            (projeto) => projeto.nome === selectedOption,
                          )?.id === status?.id_projeto,
                      )
                      .map((status) => (
                        <SelectItem key={status.id} value={status.nome}>
                          {status.nome}
                        </SelectItem>
                      ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    className="w-[220px] justify-start text-left font-normal"
                  >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {dataInicio
                      ? format(dataInicio, 'dd/MM/yyyy', { locale: ptBR })
                      : 'HUs criadas a partir de'}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                  <Calendar
                    mode="single"
                    selected={dataInicio}
                    onSelect={setDataInicio}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>
              <Button
                className="bg-[#3900DB] buttonAplicarFiltrosPlanejamento"
                onClick={() => {
                  setIdProjeto(
                    projetos.find((projeto) => projeto.nome === selectedOption)
                      ?.id,
                  );
                  setEpicoSelecionadoGantt(epicoSelecionado);
                  setStatusSelecionadoGantt(statusSelecionado);
                  setTermoPesquisaGantt(termoPesquisa);
                  setDataInicioGantt(dataInicio);
                }}
              >
                Aplicar filtros
              </Button>
            </div>
            <div
              className="gantt-scroll-wrapper"
              style={{
                width: '100%',
                overflowX: 'visible',
                overflowY: 'visible',
              }}
            >
              <GanttComponent
                idProjeto={idProjeto}
                epicoSelecionado={epicoSelecionadoGantt}
                statusSelecionado={statusSelecionadoGantt}
                termoPesquisa={termoPesquisaGantt}
                dataInicio={dataInicioGantt}
                setGanttHasData={setGanttHasData}
              />
            </div>
            <ModalEditNameEpic options={epicos} />
            {ganttHasData ? (
              ''
            ) : (
              <div style={{ display: 'flex', marginTop: '5rem' }}>
                <Tour />
              </div>
            )}
          </div>
        )}

        {activeTab === 'epics' && (
          <div className="w-[80%] p-8 max-w-none flex flex-col items-center align-self-center">
            <h1 className="text-3xl text-[#020817] font-semibold mb-4">
              Épicos
            </h1>
            <h2 className="text-xl mb-4 text-[#6B7280] w-full text-center">
              Realize o upload do modelo do épico para associação ao projeto.
            </h2>
            <div className="flex gap-12 mb-4 w-full justify-center">
              <div className="flex flex-col items-start gap-4">
                <label className="font-medium w-40">Modelo do épico:</label>
                <Input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileChange}
                  disabled={uploading}
                  className="w-full p-2 border rounded-md"
                />
                {epicFile && (
                  <span className="text-gray-600">{epicFile.name}</span>
                )}
              </div>
              <div className="flex flex-col items-start gap-4">
                <label className="font-medium w-60">Projeto associado:</label>
                <Select
                  value={selectedUploadProject}
                  onValueChange={setSelectedUploadProject}
                >
                  <SelectTrigger className="w-[201px]">
                    <SelectValue placeholder="Selecionar projeto" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      {projetos.map((proj) => (
                        <SelectItem key={proj.id} value={proj.id.toString()}>
                          {proj.nome}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div className="mb-6 w-full flex justify-start">
              <Button
                className="bg-white text-[#3B82F6] hover:bg-gray-300"
                style={{ borderWidth: '1px', borderColor: '#3B82F6' }}
                onClick={handleDownloadModel}
              >
                Baixar modelo de preenchimento
              </Button>
            </div>

            {epicManagementStep === 1 && (
              <div className="flex gap-4 w-full justify-end">
                <Button
                  className="bg-[#F4F4F5] text-[#A1A1AA] hover:bg-[#9A9AA2] hover:text-white"
                  onClick={() => {
                    setEpicFile(null);
                    setSelectedUploadProject('');
                  }}
                  disabled={uploading}
                >
                  Cancelar
                </Button>
                <Button
                  className="bg-[#18181B] text-white hover:bg-gray-700"
                  onClick={handleInitialUpload}
                  disabled={!epicFile || !selectedUploadProject || uploading}
                >
                  {uploading ? (
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  ) : (
                    ''
                  )}
                  {uploading ? 'Carregando modelo' : 'Fazer upload'}
                </Button>
              </div>
            )}

            {epicManagementStep === 2 && (
              <div
                className="w-full mt-6"
                style={{
                  borderTop: '2px dashed #0069988C',
                }}
              >
                <div className="mb-4 flex justify-end items-center gap-x-4 mt-7">
                  <div className="flex-column">
                    <label className="font-medium mb-2">Selecionar Aba</label>
                    <Select value={sheetName} onValueChange={setSheetName}>
                      <SelectTrigger className="w-[220px]">
                        <SelectValue placeholder="Selecione a aba" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectGroup>
                          {sheetTabs.map((tab) => (
                            <SelectItem key={tab} value={tab}>
                              {tab}
                            </SelectItem>
                          ))}
                        </SelectGroup>
                      </SelectContent>
                    </Select>
                  </div>
                </div>

                <h2 className="text-xl font-bold pt-4 mb-5">
                  Mapeamento dos campos:
                </h2>

                <div className="overflow-y-auto max-h-[400px] mb-4 border border-gray-300 rounded-md">
                  <Table className="min-w-full bg-white">
                    <TableHeader className="sticky top-0 bg-white z-10">
                      <TableRow>
                        <TableHead className="py-2 px-4 border-b text-left">
                          CÉLULA*
                        </TableHead>
                        <TableHead className="py-2 px-4 border-b text-left">
                          NOME DA COLUNA*
                        </TableHead>
                        <TableHead className="py-2 px-4 border-b text-left">
                          MAPEAMENTO*
                        </TableHead>
                        <TableHead className="py-2 px-4 border-b text-left">
                          AÇÕES
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {fieldMappings.map((mapping) => (
                        <TableRow key={mapping.id}>
                          <TableCell className="py-2 px-4 border-b">
                            <Input
                              type="text"
                              value={mapping.cell}
                              onChange={(e) =>
                                handleFieldChange(
                                  mapping.id,
                                  'cell',
                                  e.target.value,
                                )
                              }
                              placeholder="Ex: A1"
                              className="w-full p-1 border rounded"
                            />
                          </TableCell>
                          <TableCell className="py-2 px-4 border-b">
                            <Input
                              type="text"
                              value={mapping.columnId}
                              onChange={(e) =>
                                handleFieldChange(
                                  mapping.id,
                                  'columnId',
                                  e.target.value,
                                )
                              }
                              placeholder="Ex: ID"
                              className="w-full p-1 border rounded"
                            />
                          </TableCell>
                          <TableCell className="py-2 px-4 border-b">
                            <Select
                              value={mapping.taigaField}
                              onValueChange={(value) =>
                                handleFieldChange(
                                  mapping.id,
                                  'taigaField',
                                  value,
                                )
                              }
                            >
                              <SelectTrigger className="w-full p-1">
                                <SelectValue placeholder="SELECIONAR CAMPO" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectGroup>
                                  {availableMappings.map((option) => (
                                    <SelectItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </SelectItem>
                                  ))}
                                </SelectGroup>
                              </SelectContent>
                            </Select>
                          </TableCell>
                          <TableCell className="py-2 px-4 border-b">
                            <Button
                              variant="destructive"
                              size="sm"
                              onClick={() => handleRemoveMappingRow(mapping.id)}
                            >
                              Remover
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>

                <div className="flex justify-end gap-4 mt-6">
                  <div className="w-full flex justify-start">
                    <Button variant="outline" onClick={handleAddMappingRow}>
                      Adicionar Linha
                    </Button>
                  </div>

                  <Button
                    className="bg-[#DC2626] text-white hover:bg-[#A92121]"
                    onClick={() => setEpicManagementStep(1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    className="bg-[#18181B] text-white hover:bg-gray-700"
                    onClick={handleMapAndPreview}
                    disabled={uploading}
                  >
                    {uploading ? (
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    ) : (
                      ''
                    )}
                    Continuar
                  </Button>
                </div>
              </div>
            )}

            {epicManagementStep === 3 && (
              <div className="w-full mt-6 mb-4">
                <h3 className="font-semibold mb-2">
                  Pré-visualização dos Épicos:
                </h3>
                {previewEpics.length > 0 ? (
                  <>
                    <div className="overflow-x-auto">
                      <Table className="min-w-full bg-white border border-gray-300">
                        <TableHeader>
                          <TableRow>
                            <TableHead className="py-2 px-4 border-b">
                              ID
                            </TableHead>
                            <TableHead className="py-2 px-4 border-b">
                              HISTÓRIA DE USUÁRIO
                            </TableHead>
                            <TableHead className="py-2 px-4 border-b">
                              DESCRIÇÃO DA HISTÓRIA DE USUÁRIO
                            </TableHead>
                            <TableHead className="py-2 px-4 border-b">
                              HORAS DEDICADAS À ATIVIDADE
                            </TableHead>
                            <TableHead className="py-2 px-4 border-b">
                              ETIQUETAS
                            </TableHead>
                            <TableHead className="py-2 px-4 border-b">
                              TOTAL DE HORAS DEDICADAS AO ÉPICO
                            </TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {paginatedEpics.map((epic, idx) => (
                            <React.Fragment key={epic.subject || idx}>
                              <TableRow>
                                <TableCell
                                  className="py-1 px-4 border-b text-sm text-black align-middle"
                                  rowSpan={epic.stories?.length || 1}
                                >
                                  {epic.subject}
                                </TableCell>
                                <TableCell className="py-1 px-4 border-b text-sm text-black">
                                  {epic.stories?.[0]?.subject || 'N/A'}
                                </TableCell>
                                <TableCell className="py-1 px-4 border-b text-sm text-black">
                                  {epic.stories?.[0]?.description || 'N/A'}
                                </TableCell>
                                <TableCell className="py-1 px-4 border-b text-sm text-black">
                                  {epic.stories?.[0]?.tempoGasto || 'N/A'}
                                </TableCell>
                                <TableCell
                                  className="py-1 px-4 border-b text-sm text-black min-w-[200px]"
                                  style={{ verticalAlign: 'top' }}
                                >
                                  <div className="flex flex-col gap-1 mt-1">
                                    <label className="mb-2 font-medium">
                                      Selecionar etiquetas
                                    </label>
                                    <ReactSelect
                                      isMulti
                                      options={projectTags} // Make sure projectTags is the source
                                      value={projectTags.filter((opt) =>
                                        (
                                          storyTags[`${epic.subject}-0`] || []
                                        ).includes(opt.value),
                                      )}
                                      onChange={(selected) =>
                                        handleStoryTagsChangeReactSelect(
                                          epic.subject,
                                          0,
                                          selected,
                                        )
                                      }
                                      placeholder="Selecionar etiquetas"
                                      menuPortalTarget={document.body}
                                      classNamePrefix="select-tags"
                                      styles={tagSelectStyles}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="py-1 px-4 border-b text-sm text-black align-middle"
                                  rowSpan={epic.stories?.length || 1}
                                >
                                  {epic.tempoEsperado || 0}
                                </TableCell>
                              </TableRow>
                              {epic.stories &&
                                epic.stories.length > 1 &&
                                epic.stories.slice(1).map((story, storyIdx) => (
                                  <TableRow
                                    key={`${epic.subject}-${story.subject}-${storyIdx + 1}`}
                                  >
                                    <TableCell className="py-1 px-4 border-b text-sm text-black">
                                      {story.subject || 'N/A'}
                                    </TableCell>
                                    <TableCell className="py-1 px-4 border-b text-sm text-black">
                                      {story.description}
                                    </TableCell>
                                    <TableCell className="py-1 px-4 border-b text-sm text-black">
                                      {story.tempoGasto || 'N/A'}
                                    </TableCell>
                                    <TableCell
                                      className="py-1 px-4 border-b text-sm text-black min-w-[200px]"
                                      style={{ verticalAlign: 'top' }}
                                    >
                                      <div className="flex flex-col gap-1 mt-1">
                                        <label className="mb-2 font-medium">
                                          Selecionar etiquetas
                                        </label>
                                        <ReactSelect
                                          isMulti
                                          options={projectTags}
                                          value={projectTags.filter((opt) =>
                                            (
                                              storyTags[
                                                `${epic.subject}-${storyIdx + 1}`
                                              ] || []
                                            ).includes(opt.value),
                                          )}
                                          onChange={(selected) =>
                                            handleStoryTagsChangeReactSelect(
                                              epic.subject,
                                              storyIdx + 1,
                                              selected,
                                            )
                                          }
                                          placeholder="Selecionar etiquetas"
                                          classNamePrefix="react-select"
                                          menuPortalTarget={document.body}
                                          styles={tagSelectStyles}
                                        />
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </React.Fragment>
                          ))}
                        </TableBody>
                      </Table>
                    </div>

                    <div className="flex items-center justify-between mt-4 w-full">
                      <div className="flex items-center gap-2">
                        <span className="font-medium">Linhas por página</span>
                        <ReactSelect
                          options={itemsPerPageSelectOptions}
                          value={itemsPerPageSelectOptions.find(
                            (opt) => opt.value === itemsPerPage,
                          )}
                          onChange={(selectedOption) => {
                            setItemsPerPage(selectedOption.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          classNamePrefix="react-select"
                          styles={{
                            container: (base) => ({ ...base, width: '90px' }),
                            control: (base) => ({ ...base, minHeight: '32px' }),
                            valueContainer: (base) => ({
                              ...base,
                              padding: '0 8px',
                            }),
                            indicatorSeparator: () => ({ display: 'none' }),
                          }}
                        />
                      </div>
                      <div className="flex items-center gap-2 font-semibold">
                        <button
                          className="h-8 w-8 flex items-center justify-center rounded disabled:opacity-50 hover:bg-neutral-100"
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          {'<'}
                        </button>
                        {generatePagination(currentPage, totalPages).map(
                          (page, idx) => {
                            if (page === '...') {
                              return (
                                <span
                                  key={`ellipsis-${idx}`}
                                  className="h-8 w-8 flex items-center justify-center"
                                >
                                  ...
                                </span>
                              );
                            }
                            return (
                              <button
                                key={page}
                                className={`
                                h-8
                                w-8
                                flex
                                items-center
                                justify-center
                                rounded
                                ${
                                  currentPage === page
                                    ? 'border'
                                    : 'hover:bg-neutral-100'
                                }`}
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            );
                          },
                        )}
                        <button
                          className="h-8 w-8 flex items-center justify-center rounded disabled:opacity-50 hover:bg-neutral-100"
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          {'>'}
                        </button>
                      </div>
                    </div>

                    <div className="flex justify-end gap-4 mt-6">
                      <Button
                        className="bg-[#DC2626] text-white hover:bg-[#A92121]"
                        onClick={() => setEpicManagementStep(2)}
                      >
                        Voltar
                      </Button>
                      <Button
                        className="bg-[#18181B] text-white hover:bg-gray-700"
                        onClick={handleUploadEpics}
                        disabled={uploading || !selectedUploadProject}
                      >
                        {uploading ? (
                          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        ) : (
                          ''
                        )}
                        {uploading ? 'Enviando...' : 'Confirmar cadastro'}
                      </Button>
                    </div>
                  </>
                ) : (
                  <p className="text-gray-600">
                    Nenhum épico para pré-visualizar. Faça o upload do arquivo.
                  </p>
                )}
              </div>
            )}
          </div>
        )}

        {activeTab === 'wbs' && (
          <div style={pageWidth}>
            <Wbs />
          </div>
        )}

        {activeTab === 'kanban' && (
          <div style={pageWidth}>
            <Kanban />
          </div>
        )}
      </div>
      <ToastContainer />
    </>
  );
}